import React, { useEffect, useState } from "react";
import "./panel.scss";
import SiteTexts from "utils/Texts";
import StatisticsCard from "components/StatisticsCard/StatisticsCard";
import ProgressBox from "components/ProgressBox/ProgressBox";
import Table from "components/Table/Table";
import { Link } from "react-router-dom";
import { Labels } from "../../../utils/Labels";
import { URL_Route } from "urlRouts";
import { useSelector } from "react-redux";

interface Props {
  dashboardData: any;
  gotData: boolean;
}

const DashboardDesktopPage: React.FC<Props> = ({ dashboardData, gotData }) => {
  const [sumProgressBox, setSumProgressBox] = useState<number>(1);
  const SiteText = SiteTexts();
  const userStates = useSelector((state: any) => state.userState);

  useEffect(() => {
    if (gotData === true) {
      setSumProgressBox(
        dashboardData.apartmentCount +
          dashboardData.housePercent +
          dashboardData.officeCount +
          dashboardData.penthouseCount +
          dashboardData.buildingCount +
          dashboardData.villaCount
      );
    }
  }, [gotData]);

  const TableHeader = ["Property Info", "Type", "Posted", "Action"];

  return (
    <div className="panel-main-parent">
      <div className="top-cards-parent">
        {gotData === true ? (
          <>
            {userStates.role === "Advisor" ? (
              <></>
            ) : (
              <StatisticsCard
                customClass={"purple-card"}
                text={"CONTACT REQUEST"}
                count={dashboardData.contactRequestCount}
                link={URL_Route.Contact_Request}
                icon={"https://delta.ir/Content/css/img/star.svg"}
              />
            )}
            {userStates.role === "Admin" ? (
              <StatisticsCard
                customClass={"yellow-card"}
                text={"RENTAL REQUEST"}
                count={dashboardData.rentalRequestCount}
                link={URL_Route.Rental_Request}
                icon={"https://delta.ir/Content/css/img/star.svg"}
              />
            ) : (
              <></>
            )}
            {userStates.role === "Advisor" ? (
              <></>
            ) : (
              <StatisticsCard
                customClass={"red-card"}
                text={"SUBMITED PROPERTY"}
                count={dashboardData.requestCount}
                link={URL_Route.Submited_Property}
                icon={"https://delta.ir/Content/css/img/star.svg"}
              />
            )}
            <StatisticsCard
              customClass={"green-card"}
              text={"AGENT REQUEST"}
              count={dashboardData.agentRequestCount}
              link={URL_Route.Agent_Request}
              icon={"https://delta.ir/Content/css/img/star.svg"}
            />
          </>
        ) : (
          <div style={{ height: "159px" }}></div>
        )}
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "start",
          marginTop: "25px",
          position: "relative",
        }}
      >
        <div className="approved-properties-parent">
          <h4>{SiteText.PANEL.LAST_APPROVED_PROPERTIES}</h4>
          {gotData ? (
            <Table
              TableHeader={TableHeader}
              TableContent={dashboardData.depositList}
              TableContentName={"panelApprovedProperties"}
              HeaderMinWidth={["190px", "120px", "100px", "80px"]}
            />
          ) : (
            <div style={{ height: "380px" }}></div>
          )}
          <Link className="see-more-btn" to={URL_Route.Property_List}>
            {Labels.ButtonLabels.SEE_ALL_LISTING}
          </Link>
        </div>
        <div className="progress-box">
          <h4>{SiteText.PANEL.PROGRESS_BOX_TITLE}</h4>
          {gotData ? (
            <>
              <ProgressBox
                color={"#e65251"}
                text={"Apartment"}
                value={dashboardData.apartmentCount}
                valueSum={sumProgressBox}
              />
              <ProgressBox
                color={"#ffaf00"}
                text={"House"}
                value={dashboardData.housePercent}
                valueSum={sumProgressBox}
              />
              <ProgressBox
                color={"#8862e0"}
                text={"Office"}
                value={dashboardData.officeCount}
                valueSum={sumProgressBox}
              />
              <ProgressBox
                color={"#424964"}
                text={"Pent House"}
                value={dashboardData.penthouseCount}
                valueSum={sumProgressBox}
              />
              <ProgressBox
                color={"#308ee0"}
                text={"Building"}
                value={dashboardData.buildingCount}
                valueSum={sumProgressBox}
              />
              <ProgressBox
                color={"#00ce68"}
                text={"Villa"}
                value={dashboardData.villaCount}
                valueSum={sumProgressBox}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardDesktopPage;
